// @flow

class MyClass {
    constructor() {}
}
